import React, { useState, useMemo, useCallback, useEffect } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { FormCustom, Input, Radio, Select } from '../../Components/Form/Form';
import Button from 'react-bootstrap/Button'
import Loading from '../../Components/Layout/Styled/Loading'
import { useSelector } from 'react-redux';
import ReactPlaceholder from 'react-placeholder/lib';

const ReporteRed = ({ isAdmin }) => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    const [reporte, setReport] = useState({})
    const jwt = useSelector(store => store.session.jwt)
    const [period, setPeriod] = useState([])
    const [ready, setReady] = useState(false)
    const [periodSelected, setPeriodSelected] = useState('')

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_customers', text: 'ID', align: 'center' },
                { name: 'id_upline', text: 'Upline', align: 'center' },
                { name: 'id_sponsor', text: 'Sponsor', align: 'center' },
                { name: 'full_name', text: 'Nombres' },
                { name: 'nivel', text: 'Nivel', align: 'center' },
                { name: 'name_plan', text: 'Rango', align: 'center' },
                { name: 'date_registration', text: 'Fecha de Ingreso', align: 'center' },
                {
                    name: 'point_current_customers', text: 'Puntos', align: 'center', render: r => {
                        return <div className={'badge badge-' + (parseInt(r.point_current_customers) >= Helpers.config.pointMinRange ? 'success' : (parseInt(r.point_current_customers) > 0 ? 'warning' : 'danger'))}>
                            {r.point_current_customers}
                        </div>
                    }
                },
                { name: 'point_business_customers', text: 'Valor Negocio', align: 'center' },
                {
                    name: 'id_status', text: 'Estatus', align: 'center', render: r => <div className={'badge badge-' + (parseInt(r.id_status) === 1 ? 'success' : 'danger')}>
                        {parseInt(r.id_status) === 1 ? 'Activo' : 'De Baja'}
                    </div>
                },
                { name: 'key_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'code_country', text: 'País', align: 'center' },
            ],
        ]}
        rows={rows ? rows : []}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    const [data, setData] = useState({
        p_id_customers: '',
        p_full_name_customers: '',
        p_id_state: 1,
        p_point_min: '',
        p_point_max: '',
        p_type: 'COMISIONES'
    })
    const [showLoading, setShowLoading] = useState(false)
    const [states] = useState([
        { name_state: 'Todos', id_state: -1 },
        { name_state: 'Activo', id_state: 1 },
        { name_state: 'De Baja', id_state: 0 },
    ])

    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
            setReady(true);
        })
    }, [])

    const cboState = useCallback(() => {
        let findState = states.find(w => parseInt(w.id_state) === parseInt(data.p_id_state))

        if (!findState) {
            return ''
        }

        return {
            label: findState.name_state,
            value: findState.id_state
        }
    }, [states, data.p_id_state])

    // if (Helpers.date.get({ format: '%Y-%m-%d' }) >= '2026-02-18') {
    //     return <></>
    // }

    return <>
        <ReactPlaceholder rows={10} showLoadingAnimation ready={ready}>
            <Card>
                <Card.Header className="justify-content-between">
                    <span>Descendencia de Red</span>
                </Card.Header>
                <Card.Body>
                    <FormCustom viewSubmit={false} onSubmit={_ => {
                        if (isNaN(parseInt(periodSelected))) {
                            Helpers.toast.construct({
                                response: 'warning',
                                message: 'Debe seleccionar un periodo',
                                toast
                            })
                            return
                        }
                        setRows([])
                        setIsProccesing(true)
                        setShowLoading(true)
                        setReport({})
                        Controllers.red.get_find_red({
                            p_id_customers: data.p_id_customers,
                            p_id_state: data.p_id_state === -1 ? '' : data.p_id_state,
                            p_point_min: data.p_point_min,
                            p_point_max: data.p_point_max,
                            p_type: data.p_type,
                            p_id_period: periodSelected,
                        }).then(res => {
                            if (res.response !== 'success') {
                                Helpers.toast.construct({ ...res, toast })
                                return
                            }
                            setData({ ...data, p_id_customers: res.data.id_customers, p_full_name_customers: res.data.name_customers })
                            setRows(res.data.rows)
                            setReport({
                                excel: res.data.excel.file,
                                filename: res.data.excel.filename,
                            })
                        }).catch(req => Helpers.promise.catch({ req, toast }))
                            .finally(() => {
                                setIsProccesing(false)
                                setShowLoading(false)
                            })
                    }}>
                        {isAdmin && <>
                            <Input
                                classNameParent="col-12 mb-2"
                                type="number"
                                pattern="[0-9]{1,9}"
                                icon="fa fa-user"
                                placeholder="Id Cliente"
                                text="Id Cliente"
                                required
                                onChange={e => {
                                    setData({ ...data, p_id_customers: e.currentTarget.value, p_full_name_customers: '' })
                                    setRows([])
                                    setReport({})
                                }}
                                append={[
                                    <Button type="submit">
                                        <i className="fa fa-search"></i>
                                    </Button>
                                ]}
                                value={data.p_id_customers}
                            />
                            <Input
                                classNameParent="col-12 mb-2"
                                icon="fa fa-user"
                                placeholder="Nombre Cliente"
                                text="Nombre Cliente"
                                required
                                disabled
                                value={data.p_full_name_customers}
                            />
                        </>}
                        <Select
                            icon="fa fa-building"
                            text="Periódo"
                            classNameParent="col-12 mb-2"
                            options={period.map(p => {
                                return {
                                    label: p.name_period,
                                    value: p.id_period
                                }
                            })}
                            onChange={e => setPeriodSelected(e.value)}
                            append={isAdmin ? [] : [
                                <Button type="submit">
                                    <i className="fa fa-search"></i>
                                </Button>
                            ]}
                        />
                        <Select
                            classNameParent="col-12 mb-2"
                            icon="fa fa-user"
                            text="Estado"
                            required
                            onChange={e => {
                                setData({ ...data, p_id_state: e.value })
                                setRows([])
                                setReport({})
                            }}
                            value={cboState()}
                            options={states.map(w => {
                                return {
                                    label: w.name_state,
                                    value: w.id_state
                                }
                            })}
                        />
                        <Input
                            classNameParent="col-6 mb-2"
                            icon="fa fa-user"
                            placeholder="Puntos Mínimos"
                            text="Puntos Mínimos"
                            type="number"
                            value={data.p_point_min}
                            onChange={e => {
                                setData({ ...data, p_point_min: e.currentTarget.value })
                                setRows([])
                                setReport({})
                            }}
                            required={data.p_point_min !== ''}
                        />
                        <Input
                            classNameParent="col-6 mb-2"
                            icon="fa fa-user"
                            placeholder="Puntos Máximos"
                            text="Puntos Máximos"
                            type="number"
                            value={data.p_point_max}
                            onChange={e => {
                                setData({ ...data, p_point_max: e.currentTarget.value })
                                setRows([])
                                setReport({})
                            }}
                            required={data.p_point_max !== ''}
                        />
                        <div className="col-12">
                            <div className="d-flex">
                                <Radio
                                    id="rdb-fechas"
                                    classNameParent="mr-3 mb-2"
                                    text="Comisiones"
                                    checked={data.p_type === 'COMISIONES'}
                                    onChange={e => {
                                        setData({ ...data, p_type: 'COMISIONES' })
                                        setReport({})
                                        setRows([])
                                    }}
                                />
                                <Radio
                                    id="rdb-periodo"
                                    classNameParent=""
                                    text="Colocación"
                                    checked={data.p_type === 'ROLL_OVER'}
                                    onChange={e => {
                                        setData({ ...data, p_type: 'ROLL_OVER' })
                                        setReport({})
                                        setRows([])
                                    }}
                                />
                            </div>
                        </div>
                    </FormCustom>
                    {reporte?.filename ? <div className='mb-4'>
                        <a href={reporte?.excel} download={reporte?.filename} className="mr-2">
                            <Button size="sm" variant="success">
                                <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                            </Button>
                        </a>
                        {data.p_type === 'ROLL_OVER' && <a href={Helpers.config.apiUrl({
                            url: '/red/order/red-roll-over/' + data.p_id_customers + '?jwt=' + jwt
                        })} target="_blank" rel='noreferrer'>
                            <Button size="sm" variant="dark">
                                <i className="fa fa-file-excel mr-2"></i>Ver Descendencia Ordenada
                            </Button>
                        </a>}
                        {data.p_type === 'COMISIONES' && <a href={Helpers.config.apiUrl({
                            url: '/red/order/red/' + data.p_id_customers + '?jwt=' + jwt
                        })} target="_blank" rel='noreferrer'>
                            <Button size="sm" variant="dark">
                                <i className="fa fa-file-excel mr-2"></i>Ver Descendencia Ordenada
                            </Button>
                        </a>}
                    </div> : ''}
                    {dtRows}
                </Card.Body>
            </Card>
            <Loading show={showLoading}>
                <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
            </Loading>
        </ReactPlaceholder>
    </>
}

ReporteRed.defaultProps = {
    isAdmin: true
}

export default ReporteRed